import React from 'react'
import { connect } from 'react-redux'
import { showAlertModal } from '../../actions'

const UtilitiesSideBar = props => {
  const { showAlertModal } = props

  const handleSupport = () => {
    window.open('https://support.dividia.net', '_blank')
    // we will not setNav for support since it will not change the main content
    // let's just notify user that we've openened a new tab for support in case they get lost
      setTimeout(() => {showAlertModal(['INFO', 'Support page opened in new tab.'])}, 500)
  }

  return (
    <div style={styles.container}>
      <button style={{ ...styles.button, ...styles.selectedButton }}>Export</button>
      <button onClick={handleSupport} style={styles.button}>Request Support</button>
    </div>
  )
}

const mapStateToProps = state => {
  return { }
}
export default connect(mapStateToProps, {showAlertModal})(UtilitiesSideBar)

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '1vmin',
  },
  button: {
    cursor: 'pointer',
    padding: '3px 10px',
    overflow: 'hidden',
    borderRadius: '5px',
    fontSize: '1.5vmin',
  },
  selectedButton: {
    backgroundColor: 'rgb(56, 172, 236)',
  },
}